// React
import React, { useEffect, useState } from "react";

// Chakra-ui
import {
  Text,
  Box,
  Stack,
  Flex,
  Image
} from '@chakra-ui/react';

// Client
import { supabase } from '../../../../../../client';

const TotalAmountCollected = () => {
  const [totalCollected, setTotalCollected] = useState(0);
  useEffect(() => {
    getTotalInitiatives();
  }, []);
  
  const getTotalInitiatives = async() => {
    const user_id = await supabase.auth.user().id;
    try {
      const { data, error } = await supabase
      .from('initiatives')
      .select('amount_collected')

      if(data && data.length > 0) {
        let newTotal = 0;
        data.map((item) => newTotal += item.amount_collected);
        setTotalCollected(new Intl.NumberFormat('de-DE').format(newTotal));
      }
    } catch (err) {
      console.log('error fetching number of actions ', err);
    }
  }

  return(
    <Box w={'346px'} p='24px' h={'108px'} bg='#EAF0E2' borderRadius={'16px'}>
      <Stack spacing={'10px'}>
        <Text fontWeight='700' color='#1C1C1C' lineHeight={'143%'} letterSpacing='0.1px'>Recaudaciones totales: Iniciativas</Text>
        <Text fontSize='24px' color='#1C1C1C' textAlign={'left'} fontWeight='700' lineHeight={'133.4%'}>{`$${totalCollected}`}</Text>
      </Stack>
    </Box>
  )
} 

export default TotalAmountCollected;